<template>
  <v-container fluid>
    <v-row class="py-8"></v-row>
    <v-divider></v-divider>
    <v-tabs :value="tab" @change="changedTab" grow>
      <v-tab v-for="tabSelect in tabList" :key="tabSelect">
        {{ tabSelect }}
      </v-tab>
    </v-tabs>
    <v-row class="px-8">
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <p class="py-1 mb-3" v-for="(item, index) in items" :key="index">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                          <span
                                  v-on="on"
                                  class="cursor-pointer mr-1 error--text"
                                  @click="removeFileId = item.id, dialog = true"
                          >
                            X
                          </span>
                </template>
                <span>Supprimer</span>
              </v-tooltip>

              <span
                @click="downloadAs(item.id, item.name, 'guide')"
                class="file-upload cursor-pointer">{{ item.name }}</span>
            </p>
            <v-file-input
              class="upload-resume"
              id="upload-resume"
              append-icon="fas fa-upload"
              @click:append="openFileInput('upload-resume')"
              @change="setFile"
              placeholder="Sélectionnez un fichier"
              outlined
              accept=".doc,.docx,.pdf"
              prepend-icon
              ref="fileupload"
            />
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn class="x-2" color="primary" @click="save" rounded depressed
              >Sauvegarder</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
            v-model="dialog"
            persistent
            max-width="380"
            @keydown.esc="dialog = false"
    >
      <v-card class="pb-5 pt-3">
        <v-img
                src="assets/img/logo-color.png"
                width="54"
                class="mx-auto mt-3"
        />
        <v-card-title class="pt-3 font-weight-medium"
        >Confirmez-vous cette action ?</v-card-title
        >

        <div class="text-center mt-5">
          <v-btn
                  class="body-1 px-7"
                  depressed
                  small
                  rounded
                  color="primary"
                  @click="removeFile(), (dialog = false)"
          >Oui</v-btn
          >
          <v-btn
                  class="body-1 mr-0 px-7 black--text"
                  depressed
                  small
                  rounded
                  color="#E1E1E1"
                  @click="dialog = false"
          >Non</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import fileService from "@/services/file";
export default {
  name: "Tab3",
  props: {
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    tab: 2,
    file: null,
    removeFileId: null,
    dialog: false,
    items: []
  }),
  created() {
    this.getFile();
  },
  methods: {
    openFileInput(id) {
      let inputUpload = document.getElementById(id);
      if(inputUpload) {
        inputUpload.click();
      }
    },
    changedTab(tab) {
      this.$emit("changeTab", tab);
    },
    setFile(file) {
      this.file = file;
    },
    async removeFile() {
      await fileService.removeFile(this.removeFileId);
      this.getFile();
    },
    async getFile() {
      let res = await fileService.getFile();
      if (res) {
        this.items = res.data;
      }
    },

    async save() {
      let formData = new FormData();
      formData.append(`file`, this.file);
      await fileService.create(formData);
      await this.getFile();
      this.$refs.fileupload.value=null;
    }
  }
};
</script>
<style lang="sass">
.upload-resume
  .v-input__slot
    fieldset
      background: #E0E0E0
</style>
